<template>
  <div class="contenedor-texto-iberos container">
    
    <template v-for="(el, key) in json.blocks">
      <template v-if="el" class="contenedor-texto">
        <!-- Paragraph -->
        <div v-if="el.type == 'paragraph'" class="paragraph" :key="key">
          <p v-html="el.data.text"></p>
        </div>

        <!-- Image -->
        <template v-else-if="el.type == 'image'">
          <div class="image-container" :key="key">
            <img :src="el.data.file.url" class="img-fluid" alt="Imagen ambiente Jaén" />
            <span v-html="el.data.caption" class="pie"></span>
          </div>
        </template>

        <!-- Header -->
        <h1 :nivel="el.data.level" v-else-if="el.type == 'header'" class="destacado" v-html="el.data.text" :key="key"></h1>

        <!-- Embed -->
        <div class="div-iframe" v-if="el.type == 'embed'" :data-service="el.data.service" :key="key">
          <iframe :src="el.data.embed"></iframe>

        </div>
        <!-- File -->
        <div class="file" v-else-if="el.type == 'attaches'" :key="key">
          <a download :href="el.data.file.url" class="btn-blue-border" rel="noopener" target="_blank">
            Descargar {{ el.data.title }}</a>
        </div>

        <!-- Slider -->
    
        <div class="contenedor-slider container" v-else-if="el.type == 'gallery'" :key="key">
          <slick ref="slick" :options="slickOptions">
            <div class="slide" v-for="(img, key) in el.data.images" :key="key">
              <img :src="img.file.url" alt="Imagen slider  ciudad de Jaen">
            </div>
          </slick>
        </div>

        <!-- Prety Link -->
        <div class="preaty-link row-center" v-if="el.type == 'linkTool'" :key="key">
          <div class="link row-start">
            <a :href="el.data.link" class="" rel="noopener" target="_blank"></a>
            <img v-if="!!el.data.meta.image" :src="el.data.meta.image.url" :alt=" el.data.meta.title" />
            <h2>{{ el.data.meta.title }}</h2>
            <p>{{ el.data.meta.description }}</p>
          </div>
        </div>

        <!-- List -->
        <section v-else-if="el.type == 'list' || el.type == 'nestedList'" :key="key">
          <template v-if="el.data.style == 'ordered'">
            <ol>
              <listComponent v-for="(item, index) in Object.assign({}, el.data.items)" :key="index" :item="item"
                :listStyle="el.data.style" />
            </ol>
          </template>
          <template v-else>
            <ul>
              <listComponent v-for="(item, index) in Object.assign({}, el.data.items)" :key="index" :item="item"
                :listStyle="el.data.style" />
            </ul>
          </template>
        </section>

        <!-- Boton -->
        <div class="button row-center" v-else-if="el.type == 'button'" :key="key">
          <a target="_blank" :href="el.data.link" class="btn green">{{
            el.data.text
            }}</a>
        </div>

        <!-- Tabla -->
        <div class="table-container row-center" v-else-if="el.type == 'table'" :key="key">
          <table>
            <tr v-for="(td, tdkey) in el.data.content" :key="tdkey">
              <td :key="ekey" v-for="(e, ekey) in td" v-html="e"></td>
            </tr>
          </table>
        </div>

        <!-- Columnas -->
        <div class="columns row-center" v-else-if="el.type == 'columns'" :key="key">
          <div class="column" v-for="(el, subkey) in el.data.itemContent" :key="subkey">
            <editorjs :object="el"></editorjs>
          </div>
        </div>

        <!-- Raw -->
        <!-- <div v-else class="raw" :key="key">
          <div v-html="el.data.html"></div>
        </div> -->
      </template>
    </template>
  </div>
</template>

<script>
  import Slick from 'vue-slick';
  import listComponent from "@/components/parts/list-component";
  
  export default {
    name: "editorjs",
    props: ["object"],
    computed: {
      json() {
        if (typeof this.object === "string" || this.object instanceof String) {
          return JSON.parse(this.object);
        }
        return this.object;
      },
    },
    data: () => ({
      slickOptions: {
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 620,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        },
    }),

    components: {
      listComponent,
      Slick,
    },
    filters: {},
  };
</script>
<style>
  ol {
    counter-reset: item;
  }

  ol li {
    display: block;
  }

  .button {
    margin-bottom: 20px;
  }

  ol li:before {
    content: counters(item, ".") " ";
    counter-increment: item;
  }

  h4 {
    margin-bottom: 15px;
  }

  .slide {
    padding: 10px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .slide .img-content {
    width: 100%;
    height: 200px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 20px;
  }

  .slide img {
    width: 100%;
  }

 
  </style>


// WEBPACK FOOTER //
// src/components/parts/editorJs.vue